{
  "name": "@uppy/provider-views",
  "description": "View library for Uppy remote provider plugins.",
  "version": "5.1.0",
  "license": "MIT",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --environment=jsdom --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "uppy"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.css": "./dist/style.css",
    "./css/style.scss": "./src/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/utils": "workspace:^",
    "classnames": "^2.2.6",
    "nanoid": "^5.0.9",
    "p-queue": "^8.0.0",
    "preact": "^10.5.13"
  },
  "devDependencies": {
    "@types/gapi": "^0.0.47",
    "@types/google.accounts": "^0.0.14",
    "@types/google.picker": "^0.0.42",
    "cssnano": "^7.0.7",
    "jsdom": "^26.1.0",
    "postcss": "^8.5.6",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  }
}
